import { GameType } from "./prompts";

export const AI_MODELS = {
  sonnet: "claude-3-5-sonnet-20241022",
  sonnet37: "claude-3-7-sonnet-20250219",
  sonnet4: "claude-sonnet-4-20250514",
  gpt4o: "gpt-4o",
} as const;

export type AIModel = keyof typeof AI_MODELS;

export interface Prompt {
    step: number;
    id: string;
    systemPrompt: string;
    model: string;
}

export interface PromptResponse {
    promptKey: string;
    subject: string;
    teachingPersonality: string;
    prompts: Prompt[];
}

export interface GenerationRequest {
    modelName: string;
    prompt: string;
    systemPrompt: string;
    parameters: { [key: string]: any };
    stream: boolean;
    imageUrls: string[];
}

export interface AIGenerationResponse {
    success: boolean;
    errorMessage: string;
    metadata: { [key: string]: any };
    response: string;
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
}

export interface StreamOptions {
    onEnd?: () => void;
    signal?: AbortSignal;
}

class PromptService {
    private baseUrl = process.env.REACT_APP_SAAS_API_BASE_URL+'LLM';
    systemPrompt = ""
    model = ""
    orgId = ""
    userId = ""
    constructor(orgId: string, userId: string, key: string, subject: string, teachingPersonality: string, isSystemPromptAvailable: boolean = false) {
        this.orgId = orgId;
        this.userId = userId;
    }

    async getSystemPrompt() {
        var response = await this.getPrompt(this.orgId, this.userId, "InteractiveSystemPrompt", '', '');
        console.log("vvv get system prompt response", response);
        this.model = response.prompts[0].model;
        this.systemPrompt = response.prompts[0].systemPrompt;
        return this.systemPrompt;
    }

    async getModel() {
        return this.model;
    }

    async getFinalPrompt(type: string) {
        var systemPrompt = await this.getSystemPrompt();
        var response = await this.getPrompt(this.orgId, this.userId, type, '', '');
        const currentPrompt = response.prompts[0].systemPrompt;
        this.model = response.prompts[0].model;
        if (type === GameType.SIMULATION) {
            return currentPrompt;
        }
        this.systemPrompt = systemPrompt.replace("{{GAMETYPEREQUIREMENTS}}", currentPrompt);
        return this.systemPrompt;
    }

    async getQuestionGenerationPrompt(gameType: string): Promise<string | null> {
        try {
            const promptKey = `${gameType}-question-prompt`;
            const response = await this.getPrompt(this.orgId, this.userId, promptKey, '', '');
            
            if (response.prompts && response.prompts.length > 0) {
                this.model = response.prompts[0].model;
                return response.prompts[0].systemPrompt;
            }
            
            return null;
        } catch (error) {
            console.warn(`No question generation prompt found for ${gameType}, will use fallback`);
            return null;
        }
    }

    async getTemplateCode(gameType: string): Promise<string | null> {
        try {
            const promptKey = `${gameType}-template`;
            const response = await this.getPrompt(this.orgId, this.userId, promptKey, '', '');
            
            if (response.prompts && response.prompts.length > 0) {
                this.model = response.prompts[0].model;
                return response.prompts[0].systemPrompt;
            }
            
            return null;
        } catch (error) {
            console.warn(`No template code found for ${gameType}, will use fallback`);
            return null;
        }
    }

    async getRefinementPrompt(): Promise<string | null> {
        try {
            const promptKey = 'question-refinement-prompt';
            const response = await this.getPrompt(this.orgId, this.userId, promptKey, '', '');
            
            if (response.prompts && response.prompts.length > 0) {
                this.model = response.prompts[0].model;
                return response.prompts[0].systemPrompt;
            }
            
            return null;
        } catch (error) {
            console.warn('No refinement prompt found, will use fallback');
            return null;
        }
    }

    async getPrompt(
        orgId: string,
        userId: string,
        promptKey: string = '',
        subject: string = '',
        teachingPersonality: string = 'none'
    ): Promise<PromptResponse> {
        try {
            const url = new URL(`${this.baseUrl}/GetPrompt`);
            url.searchParams.append('OrgId', orgId);
            url.searchParams.append('UserId', userId);
            url.searchParams.append('PromptKey', promptKey);
            url.searchParams.append('Subject', subject);
            url.searchParams.append('TeachingPersonality', teachingPersonality);

            const response = await fetch(url.toString());
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log("vvv data", data);
            return data.data;
        }
        catch (error) {
            console.error('Error fetching prompt:', error);
            throw error;
        }
    }
}

export default PromptService;

